import _ from 'lodash';
import ElementLocale from 'element-ui/lib/locale';
/**
 * 获取当前语言的文案
 * @param lang
 * @returns
 */
export async function langGetter(lang) {
    let results: any[] = [];
    if (lang === 'cn') {
        results = await Promise.all([
            import('CommonMessages/analytics-ai-lab/cn.json'),
            import('CommonMessages/analytics-snap-business/cn.json'),
            import('CommonMessages/common-errorcode/cn.json'),
            import('CommonMessages/common-country/cn.json'),
            import('CommonMessages/common-product/cn.json'),
            import('CommonMessages/common-patent/cn.json'),
            import('element-ui/lib/locale/lang/zh-CN'),
        ]);
    } else if (lang === 'tw') {
        results = await Promise.all([
            import('CommonMessages/analytics-ai-lab/tw.json'),
            import('CommonMessages/analytics-snap-business/tw.json'),
            import('CommonMessages/common-errorcode/tw.json'),
            import('CommonMessages/common-country/tw.json'),
            import('CommonMessages/common-product/tw.json'),
            import('CommonMessages/common-patent/tw.json'),
            import('element-ui/lib/locale/lang/zh-TW'),
        ]);
    } else if (lang === 'en') {
        results = await Promise.all([
            import('CommonMessages/analytics-ai-lab/en.json'),
            import('CommonMessages/analytics-snap-business/en.json'),
            import('CommonMessages/common-errorcode/en.json'),
            import('CommonMessages/common-country/en.json'),
            import('CommonMessages/common-product/en.json'),
            import('CommonMessages/common-patent/en.json'),
            import('element-ui/lib/locale/lang/en'),
        ]);
    } else if (lang === 'jp') {
        results = await Promise.all([
            import('CommonMessages/analytics-ai-lab/jp.json'),
            import('CommonMessages/analytics-snap-business/jp.json'),
            import('CommonMessages/common-errorcode/jp.json'),
            import('CommonMessages/common-country/jp.json'),
            import('CommonMessages/common-product/jp.json'),
            import('CommonMessages/common-patent/jp.json'),
            import('element-ui/lib/locale/lang/ja'),
        ]);
    }
    const data = results.reduce((obj, { default: data }) => _.merge(obj, data), {});
    ElementLocale.use(data);
    return { [lang]: data };
}
